var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcSki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90,128.6c2.8,0,5.1-2.3,5.1-5.1V92.6c0-1.4-0.6-2.7-1.5-3.6L63.1,58.4l-45.4,45.4c-2,2-2,5.3,0,7.3s5.3,2,7.3,0L63.1,73 l21.7,21.7v28.7C84.9,126.3,87.2,128.6,90,128.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.6,
    cy: 27.1,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4,123.5c0,4.2-3.4,7.6-7.6,7.6H54v2.7h66.8c5.7,0,10.4-4.7,10.4-10.4L128.4,123.5L128.4,123.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,50c1,1,2.3,1.5,3.6,1.5c1.3,0,2.6-0.5,3.6-1.5l13-13h13.3L66.7,54.8l16.4,16.4l20.2-20.2c3.5-3.5,3.5-9.2,0-12.7 l-10-10c-1-1-2.3-1.5-3.6-1.5H69.1c-1.3,0-2.6,0.5-3.6,1.5L51,42.7c-0.6,0.6-1.1,1.4-1.3,2.3H0v2.7h49.7C49.9,48.5,50.4,49.3,51,50 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8,131.1c-2,0-4-0.8-5.4-2.2L0,97.5v3.8l29.5,29.5c2,2,4.6,3,7.3,3s5.4-1.1,7.3-3l-1.9-1.9 C40.8,130.3,38.9,131.1,36.8,131.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcSki);
export default __webpack_public_path__ + "static/media/CCSki.6f040a032fed4d92cd6006375186a6f3.svg";
export { ForwardRef as ReactComponent };